import { Box, Link } from "@mui/material";
import { Component } from "react";
import { Navigate } from "react-router";


export default class Footer extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {loggedIn: false};
        fetch('loggedIn')
        .then(res => res.json())
        .then(r => {
            this.setState({loggedIn: !r});
        })
        .catch(e => console.error(e));
    }

    render() {
        return(
            <div>
                <Box>
                    <Link href='Impressum'>Impressum</Link>
                </Box>
                {!!this.state.loggedIn && <Navigate replace to='/login'/>}
            </div>
        );
    }
}
